<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";
import Stat from "../../components/widgets/stat";
import Multiselect from 'vue-multiselect';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Stat, Multiselect },
    data() {
        return {
            title: "Laborantes",
            items: [
                {
                text: "Laborantes",
                href: "/web/configuracion/laborantes"
                },
            ],
            usuarios:[],
            // filtros
            selectedSedes: [],       // filtro por sedes (puede ser múltiple)
            selectedNombre: null,    // filtro por nombre (objeto { id, name })
            nombrePlaceholder: 'Seleccionar nombre',
            sedePlaceholder: 'Seleccionar sede',
            datos_editar:{
                sede:'',
                tipo:'',
                rut:'',
                nombre:'',
                correo:'',
                telefono:'',
                retencion:{},
                banco:{},
                tipo_cuenta:{},
                n_cuenta:''
            },
            habilitar_boton: false,
            editing: false,
            originalUser:'',
            emailError:'',
            phoneerror:'',
            bancos:[],
                exportandoExcel: false,
            tipo:['Cuenta Vista', 'Cuenta Rut', 'Cuenta Corriente', 'Cuenta Ahorro'],
            retencion:['14,5%'],
            sedes:['Viña del Mar', 'Santiago', 'Concepción'],
        };
    },
    computed: {
        // opciones de sedes (ya definidas en data.sedes)
        sedesOptions() {
            return this.sedes.slice().sort();
        },
        // nombres filtrados según sedes seleccionadas (solo aplica filtro si hay exactamente 1 sede seleccionada)
        nombresOptions() {
            let list = this.usuarios;
            // si hay exactamente 1 sede seleccionada, limitar nombres a esa sede
            if (this.selectedSedes && this.selectedSedes.length === 1) {
                list = list.filter(u => this.selectedSedes.includes((u.sede || '').toString()));
            }
            const mapped = list.map(u => ({ id: u.id, name: u.name || u.nombre || '' }));
            const uniq = [];
            const seen = new Set();
            for (const it of mapped) {
                if (!seen.has(it.id)) {
                    seen.add(it.id);
                    uniq.push(it);
                }
            }
            return uniq.sort((a,b) => a.name.localeCompare(b.name));
        },
        // usuarios filtrados: aplicar filtro por sede SOLO si hay exactamente 1 sede seleccionada,
        // además aplicar filtro por nombre si está seleccionado
        filteredUsuarios() {
            let result = this.usuarios.slice();
            // si solo hay una sede seleccionada, filtrar por esa sede; si hay 0 o >1 sedes, mostrar todo (o filtrar por nombre si corresponde)
            if (this.selectedSedes && this.selectedSedes.length === 1) {
                result = result.filter(u => this.selectedSedes.includes((u.sede || '').toString()));
            }
            if (this.selectedNombre && this.selectedNombre.id) {
                result = result.filter(u => u.id === this.selectedNombre.id);
            }
            return result;
        },
        // mantiene compatibilidad con isEmailValid existente
        isEmailValid() {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(this.datos_editar.email);
        }
    },
    mounted() {
    },
    methods: {
        msg(tipo,titulo){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                //text: '',
                showConfirmButton: false,
                timer: 5000
            });
        },
        toggleEdit(usuario) {
            this.originalUser = { ...usuario };
            if (this.editing) {
                this.isLoading=true
                axios.post('/api/editar_usuario_laborantes',this.datos_editar).then(res=>{
                    if(res.data.estado){
                        this.usuarios=res.data.usuarios;
                        this.msg(res.data.color,res.data.mensaje);
                        //window.location.reload();
                    }else{
                        this.msg(res.data.color,res.data.mensaje);
                    }
                    this.isLoading=false
                })
            }else{
                this.datos_editar.id=usuario.id;
                this.datos_editar.name=usuario.name;
                this.datos_editar.rut=usuario.rut;
                this.datos_editar.sede=usuario.sede;
                this.datos_editar.email=usuario.email;
                this.datos_editar.cargo=usuario.cargo;
                this.datos_editar.telefono=usuario.telefono;
                this.datos_editar.retencion=usuario.retencion;
                this.datos_editar.banco= this.bancos.filter((ban) => ban.id==usuario.banco)[0];
                this.datos_editar.tipo_cuenta=usuario.tipo_cuenta;
                this.datos_editar.n_cuenta=usuario.n_cuenta;
            }
            this.editing = !this.editing;
        },
        cancelEdit() {
            // Restaurar los valores originales si se cancela la edición
            //this.sucursal = { ...this.originalSucursal };
            this.editing = false;
        },
        ver_mas(usuario){
            this.editing = false;
            if (usuario.boton=='Ver más') {
                usuario.boton='Ver menos'
            }else if(usuario.boton=='Ver menos'){
                usuario.boton='Ver más'
            }
        },
        labelselect_tipo ({ nombre }) {
            return `${nombre}`
        },
        formatRut() {
            // Eliminamos todos los caracteres que no sean números o 'k'
            let cleanRut = this.datos_editar.rut.replace(/[^0-9kK]/g, "").toUpperCase();
            if (cleanRut.length > 10) {
                cleanRut = cleanRut.slice(0, 10); // Limitar a 9 dígitos + DV
            }
            // Si el RUT tiene más de un carácter, separamos el dígito verificador
            if (cleanRut.length > 1) {
                const body = cleanRut.slice(0, -1); // Todo menos el último carácter
                const dv = cleanRut.slice(-1); // Último carácter como dígito verificador
                // Agregamos los puntos cada tres dígitos al cuerpo
                const formattedBody = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                // Concatenamos el cuerpo formateado con el dígito verificador
                this.datos_editar.rut = `${formattedBody}-${dv}`;
            } else {
                // Si el RUT tiene un solo carácter, lo dejamos tal cual
                this.datos_editar.rut = cleanRut;
            }
        },
        validateEmail() {
            if (this.datos_editar.email && !this.isEmailValid) {
                this.emailError = 'El correo electrónico no es válido.';
            } else {
                this.emailError = '';
            }
        },
        formatPhoneNumber() {
            // Elimina todo lo que no sea número
            let digits = this.datos_editar.telefono.replace(/\D/g, "");
            // Agrega el prefijo "+56" si no está presente
            if (!digits.startsWith("56")) {
                digits = "56" + digits;
            }
            // Limita a un máximo de 11 caracteres (+56 + 9 dígitos)
            if (digits.length > 11) {
                digits = digits.slice(0, 11);
            }
            // Actualiza el input con el formato correcto
            this.datos_editar.telefono = "+" + digits;
        },
        validatePhoneNumber() {
            // Validar que el número tenga exactamente 11 caracteres (+56 + 9 dígitos)
            if (this.datos_editar.telefono.length !== 12) {
                this.phoneerror = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror = "";
                //alert("Número válido: " + this.datos.telefono);
                // Aquí puedes continuar con el envío del formulario
            }
        },
        restrictToNumbers(event) {
            const allowedKeys = [
                "Backspace",
                "Tab",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
            ];
            // Permitir teclas especiales y números
            if (
                !allowedKeys.includes(event.key) &&
                !/^\d$/.test(event.key) // Permitir solo números
            ) {
                event.preventDefault();
            }
        },
        restrictInput(event) {
            // Permitir solo letras y teclas de control (Backspace, Delete, etc.)
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
            const isLetter = /^[a-zA-Z]$/.test(event.key);
            if (!isLetter && !allowedKeys.includes(event.key)) {
                event.preventDefault(); // Previene la entrada de caracteres no permitidos
            }
        },
        restrictInput_withspace(event) {
            // Permitir solo letras, espacios y teclas de control (Backspace, Delete, etc.)
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
            const isLetterOrSpace = /^[a-zA-Z\s]$/.test(event.key);

            if (!isLetterOrSpace && !allowedKeys.includes(event.key)) {
                event.preventDefault(); // Previene la entrada de caracteres no permitidos
            }
        },
        obtenerBanco(element){
            let banco = this.bancos.filter((ban) => ban.id==element);
            if (banco.length>0) {
                return banco[0].nombre;
            }
        },
        eliminar(usuario){
            let formData = new FormData();
            formData.append('usuario_id', usuario.id);
            axios.post('/api/eliminar_laborante',formData).then(res=>{
                if(res.data.estado){
                    this.usuarios=res.data.usuarios;
                    this.msg(res.data.color,res.data.mensaje);
                }else{
                    this.msg(res.data.color,res.data.mensaje);
                }
            })
        },
        async actualizarRetencionMasiva(){
            const result = await Swal.fire({
                title: 'Actualizar retención laborantes',
                text: 'Ingresa el porcentaje a aplicar',
                input: 'text',
                inputValue: '15,25',
                inputPlaceholder: 'Ej: 15,25',
                showCancelButton: true,
                confirmButtonColor: "#C87838",
                confirmButtonText: 'Actualizar',
                cancelButtonText: 'Cancelar',
                inputValidator: (value) => {
                    if (!value || !String(value).trim()) {
                        return 'Debes ingresar un porcentaje';
                    }
                    const limpio = String(value).trim();
                    if (!/^\d{1,2}(,\d{1,2})?$/.test(limpio)) {
                        return 'Formato inválido. Usa formato como 15,25';
                    }
                    return null;
                }
            });

            if (!result.isConfirmed) return;

            axios.post('/api/actualizar_retencion_laborantes', {
                retencion: String(result.value).trim()
            }).then(res => {
                if (res.data && res.data.estado) {
                    this.usuarios = res.data.usuarios || this.usuarios;
                    this.msg(res.data.color || 'success', res.data.mensaje || 'Retención actualizada');
                } else {
                    this.msg((res.data && res.data.color) || 'error', (res.data && res.data.mensaje) || 'No se pudo actualizar');
                }
            }).catch(() => {
                this.msg('error', 'No se pudo actualizar la retención');
            });
        },
        exportarLaborantesExcel() {
            if (!this.usuarios.length) {
                this.msg('error', 'No hay laborantes para exportar');
                return;
            }

            this.exportandoExcel = true;

            try {
                const data = this.usuarios.map((usuario, index) => ({
                    'N°': index + 1,
                    'Nombre': usuario.name || '',
                    'Rut': usuario.rut || '',
                    'Correo': usuario.email || '',
                    'Telefono': usuario.telefono || '',
                    'Carrera': usuario.carrera || '',
                    'Ano': usuario.ano || '',
                    'Sede': usuario.sede || '',
                    'Retencion': usuario.retencion || '',
                    'Banco': this.obtenerBanco(usuario.banco) || '',
                    'Tipo Cuenta': usuario.tipo_cuenta || '',
                    'N Cuenta': usuario.n_cuenta || ''
                }));

                const ws = XLSX.utils.json_to_sheet(data);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'Laborantes');

                const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
                saveAs(blob, 'laborantes_completo.xlsx');
            } catch (error) {
                this.msg('error', 'No se pudo generar el archivo Excel');
            } finally {
                this.exportandoExcel = false;
            }
        }
    },
    created(){
        axios.get('/api/get_laborantes').then(res=>{
            this.usuarios=res.data.usuarios;
        });
        axios.get('/api/get_bancos').then(response => {
            this.bancos = response.data.bancos;
        });
    },
    watch: {
        // si cambia la selección de sedes y el nombre seleccionado ya no está en la lista, limpiar selección
        selectedSedes() {
            if (this.selectedNombre && !this.nombresOptions.find(n => n.id === this.selectedNombre.id)) {
                this.selectedNombre = null;
            }
        }
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mt-4">
                            <div class="col-md-12 mb-3 text-right">
                                <b-button variant="success" class="mr-2" @click="exportarLaborantesExcel" :disabled="exportandoExcel">
                                    <b-spinner small class="mr-2" v-if="exportandoExcel"></b-spinner>
                                    {{ exportandoExcel ? 'Generando Excel...' : 'Descargar Excel completo' }}
                                </b-button>
                                <b-button variant="primary" @click="actualizarRetencionMasiva">Actualizar retención masiva</b-button>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label>Filtrar por sede</label>
                                <multiselect
                                    v-model="selectedSedes"
                                    :options="sedesOptions"
                                    :multiple="true"
                                    :close-on-select="false"
                                    placeholder="Seleccionar sede(s)"
                                />
                            </div>
                            <div class="col-md-6 mb-3">
                                <label>Filtrar por nombre</label>
                                <multiselect
                                    v-model="selectedNombre"
                                    :options="nombresOptions"
                                    :searchable="true"
                                    :clear-on-select="true"
                                    :close-on-select="true"
                                    placeholder="Seleccionar nombre"
                                    label="name"
                                    track-by="id"
                                />
                            </div>
                         </div>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="width: 20px;">#</th>
                                        <th style="width: 400px;">Nombre</th>
                                        <th style="width: 150px;">Rut</th>
                                        <th class="text-right">Detalle</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                        <div class="table-responsive" v-for="(usuario,index) in filteredUsuarios" :key="index">
                            <table class="table">
                                <tbody>
                                    <tr>
                                        <th style="width: 20px;">{{ index+1 }}</th>
                                        <td style="width: 400px;">{{usuario.name}}</td>
                                        <td style="width: 150px;">{{usuario.rut}}</td>
                                        <td class="text-right">
                                            <b-button v-b-toggle="'accordion-'+usuario.id" variant="secondary" @click="ver_mas(usuario)">
                                                {{usuario.boton}}
                                            </b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <b-collapse :id="'accordion-'+usuario.id" accordion="my-accordion" role="tabpanel">
                                <div class="row">
                                    <div class="col-md-12" >
                                        <div class="card mt-3 shadow-sm border-light">
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <h1 class="text-primary mb-4">{{ editing ?  usuario.name : usuario.name }}</h1>
                                                        <div class="row" v-if="editing">
                                                            <div class="col-md-6">
                                                                <div class="form-group row">
                                                                    <label class="col-md-6"> Rut:</label>
                                                                    <label for="pais" class="text-primary col-md-6 text-right"> * Campo Obligatorio</label>
                                                                    <div class="col-md-12">
                                                                        <input type="text" id="rut" v-model="datos_editar.rut" class="form-control border-primary" @input="formatRut()" maxlength="12">
                                                                    </div>
                                                                </div>
                                                                <div class="form-group row">
                                                                    <label class="col-md-6"> Nombre:</label>
                                                                    <label for="pais" class="text-primary col-md-6 text-right"> * Campo Obligatorio</label>
                                                                    <div class="col-md-12">
                                                                        <input type="text" id="name" v-model="datos_editar.name" class="form-control border-primary" @keydown="restrictInput_withspace">
                                                                    </div>
                                                                </div>
                                                                <div class="form-group row">
                                                                    <label class="col-md-6"> Correo:</label>
                                                                    <label for="pais" class="text-primary col-md-6 text-right"> * Campo Obligatorio</label>
                                                                    <div class="col-md-12">
                                                                        <input type="text" id="email" v-model="datos_editar.email" class="form-control border-primary" @blur="validateEmail">
                                                                        <p v-if="emailError" class="error text-primary">{{ emailError }}</p>
                                                                    </div>
                                                                </div>
                                                                <div class="form-group row">
                                                                    <label class="col-md-6"> Teléfono:</label>
                                                                    <label for="pais" class="text-primary col-md-6 text-right"> * Campo Obligatorio</label>
                                                                    <div class="col-md-12">
                                                                        <input type="text" id="telefono" v-model="datos_editar.telefono" class="form-control border-primary" @input="formatPhoneNumber" @blur="validatePhoneNumber" @keydown="restrictToNumbers" maxlength="12">
                                                                        <p v-if="phoneerror" class="error text-primary">{{ phoneerror }}</p>
                                                                    </div>
                                                                </div>
                                                                <div class="form-group row">
                                                                    <label class="col-md-6"> Carrera:</label>
                                                                    <label for="pais" class="text-primary col-md-6 text-right"> * Campo Obligatorio</label>
                                                                    <div class="col-md-12">
                                                                        <input type="text" id="carrera" v-model="datos_editar.carrera" class="form-control border-primary" @keydown="restrictInput_withspace">
                                                                    </div>
                                                                </div>
                                                                <div class="form-group row">
                                                                    <label class="col-md-6"> Año:</label>
                                                                    <label for="pais" class="text-primary col-md-6 text-right"> * Campo Obligatorio</label>
                                                                    <div class="col-md-12">
                                                                        <input type="text" id="ano" v-model="datos_editar.ano" class="form-control border-primary" @keydown="restrictToNumbers">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-6">
                                                                <b-form-group label="Sede :" label-for="input-default">
                                                                    <multiselect
                                                                        v-model="datos_editar.sede"
                                                                        :options="sedes"
                                                                        placeholder="Seleccionar opción"
                                                                        selectLabel="Presiona para seleccionar"
                                                                        selectedLabel="Seleccionado"
                                                                        deselectLabel="Presiona para remover"
                                                                        >
                                                                        <template v-slot:noOptions>
                                                                            <p>No hay opciones</p>
                                                                        </template>
                                                                        <template v-slot:noResult>
                                                                            <p>No se encuentra coincidencia</p>
                                                                        </template>
                                                                    </multiselect>
                                                                </b-form-group>
                                                                <b-form-group label="% retención :" label-for="input-default">
                                                                    <multiselect
                                                                        v-model="datos_editar.retencion"
                                                                        :options="retencion"
                                                                        placeholder="Seleccionar opción"
                                                                        selectLabel="Presiona para seleccionar"
                                                                        selectedLabel="Seleccionado"
                                                                        deselectLabel="Presiona para remover"
                                                                        >
                                                                        <template v-slot:noOptions>
                                                                            <p>No hay opciones</p>
                                                                        </template>
                                                                        <template v-slot:noResult>
                                                                            <p>No se encuentra coincidencia</p>
                                                                        </template>
                                                                    </multiselect>
                                                                </b-form-group>
                                                                <b-form-group label="Banco :" label-for="input-default">
                                                                    <multiselect
                                                                        v-model="datos_editar.banco"
                                                                        :options="bancos"
                                                                        :custom-label="labelselect_tipo"
                                                                        placeholder="Seleccionar opción"
                                                                        selectLabel="Presiona para seleccionar"
                                                                        selectedLabel="Seleccionado"
                                                                        deselectLabel="Presiona para remover"
                                                                        >
                                                                        <template v-slot:noOptions>
                                                                            <p>No hay opciones</p>
                                                                        </template>
                                                                        <template v-slot:noResult>
                                                                            <p>No se encuentra coincidencia</p>
                                                                        </template>
                                                                    </multiselect>
                                                                </b-form-group>
                                                                <b-form-group label="Tipo cuenta :" label-for="input-default">
                                                                    <multiselect
                                                                        v-model="datos_editar.tipo_cuenta"
                                                                        :options="tipo"
                                                                        placeholder="Seleccionar opción"
                                                                        selectLabel="Presiona para seleccionar"
                                                                        selectedLabel="Seleccionado"
                                                                        deselectLabel="Presiona para remover"
                                                                        >
                                                                        <template v-slot:noOptions>
                                                                            <p>No hay opciones</p>
                                                                        </template>
                                                                        <template v-slot:noResult>
                                                                            <p>No se encuentra coincidencia</p>
                                                                        </template>
                                                                    </multiselect>
                                                                </b-form-group>
                                                                <b-form-group label="Nº Cuenta :" label-for="input-default">
                                                                    <b-form-input class="border-primary" id="input-n_cuenta" v-model="datos_editar.n_cuenta"></b-form-input>
                                                                </b-form-group>
                                                            </div>
                                                        </div>
                                                        <div class="row" v-else>
                                                            <div class="col-md-6">
                                                                <p class="font-size-16"><strong>Rut:</strong> {{ usuario.rut }}</p>
                                                                <p class="font-size-16"><strong>Nombre:</strong> {{ usuario.name }}</p>
                                                                <p class="font-size-16"><strong>Correo Electrónico:</strong> {{ usuario.email }}</p>
                                                                <p class="font-size-16"><strong>Teléfono:</strong> {{ usuario.telefono }}</p>
                                                                <p class="font-size-16"><strong>Carrera:</strong> {{ usuario.carrera }}</p>
                                                                <p class="font-size-16"><strong>Año:</strong> {{ usuario.ano }}</p>
                                                            </div>
                                                            <div class="col-md-6">
                                                                <p class="font-size-16"><strong>Sede:</strong> {{ usuario.sede }}</p>
                                                                <p class="font-size-16"><strong>% de retención:</strong> {{ usuario.retencion }}</p>
                                                                <p class="font-size-16"><strong>Banco:</strong> {{ obtenerBanco(usuario.banco) }}</p>
                                                                <p class="font-size-16"><strong>Tipo de cuenta:</strong> {{ usuario.tipo_cuenta }}</p>
                                                                <p class="font-size-16"><strong>Nº Cuenta:</strong> {{ usuario.n_cuenta }}</p>

                                                            </div>
                                                        </div>
                                                        <div class="mt-3 float-right">
                                                            <button v-if="editing" @click="cancelEdit" class="btn btn-secondary">
                                                                <i class="fas fa-times"></i> Cancelar
                                                            </button>
                                                            <button @click="toggleEdit(usuario)" class="btn btn-primary">
                                                                <i :class="editing ? 'fas fa-save' : 'fas fa-edit'"></i> {{ editing ? 'Guardar cambios' : 'Editar' }}
                                                            </button>
                                                            <b-button variant="danger" v-if="!editing" @click="eliminar(usuario)"><i class="bx bx-trash"></i></b-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-collapse>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
